import {DrawFrmThing} from "../drawfrm/DrawFrmThing";
import {ElevationApp} from "../ElevationApp";
import {FrmRefPoint} from "../drawfrm/FrmRefPoint";
import {FrmVar} from "../drawfrm/FrmVar";
import {lineBlueHeavy} from "../const";
import {CellFill, fillColor} from "./CellFill";

// one pane of a lite or fixed-panel cell drawn in plan (top-down) section: a filled
// rectangle the cell's width wide and the door-plane thick, coloured by material
// (blue for glass, grey/tan for a solid panel). Which rabbet it sits in — and so
// which side of the stop — is set by the anchor the run links it to, not here; a
// double-glazed cell is two of these, one per rabbet. Exposes the same four corner
// anchors as DoorTopDown so the top-down chain can link it between mullion profiles
// the same way it links a door. Units are mm; the scene auto-scales to fit.
export class PanelTopDown extends DrawFrmThing {

    private material: CellFill["material"];
    // draw the outline only: a secondary door slot, whose door is another opening's.
    private outlineOnly: boolean;

    // width is the (solved) cell width; height is the door-plane thickness so the
    // section sits in line with the door. Both dynamic — corners + rect track them.
    private width: FrmVar;
    private height: FrmVar;

    topLeft!: FrmRefPoint;
    bottomLeft!: FrmRefPoint;
    topRight!: FrmRefPoint;
    bottomRight!: FrmRefPoint;

    constructor(elev: ElevationApp, material: CellFill["material"], width: FrmVar, opts?: {outlineOnly?: boolean}) {
        super();

        this.material = material;
        this.outlineOnly = !!opts?.outlineOnly;
        this.width = width;
        this.height = elev.frameSpec.doorFrameProfile.doorThickness;

        const w = this.width.get();
        const h = this.height.get();

        FrmRefPoint.buildGroup(() => {
            this.topLeft = this.makeRef("panel:topLeft", 0, 0);
            this.bottomLeft = this.makeRef("panel:bottomLeft", 0, h);
            this.topRight = this.makeRef("panel:topRight", w, 0);
            this.bottomRight = this.makeRef("panel:bottomRight", w, h);
        });

        const onChange = () => this.update();
        this.trackSubscription(this.width.subscribe(onChange));
        this.trackSubscription(this.height.subscribe(onChange));

        this.draw();
    }

    private update() {
        const w = this.width.get();
        const h = this.height.get();

        this.topLeft.calculatedPoint?.set(0, 0);
        this.bottomLeft.calculatedPoint?.set(0, h);
        this.topRight.calculatedPoint?.set(w, 0);
        this.bottomRight.calculatedPoint?.set(w, h);
    }

    draw() {
        const width = this.width.get();
        const height = this.height.get();

        this.update();

        const g = this.lines;
        g.clear();
        g.lineStyle(1, lineBlueHeavy, 1);
        if(!this.outlineOnly) g.beginFill(fillColor(this.material), 1);
        g.drawRect(0, 0, width, height);
        if(!this.outlineOnly) g.endFill();
    }
}
